import Img, { FluidObject } from "gatsby-image"
import React from "react"
import styled, { css } from "styled-components"
import VariantContainer from "../atoms/variant-container"

const TestimonialSelectorButton = styled.button<{ $active: boolean }>`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  padding: 12px;
  transition: all 0.4s ease-out;
  /* If active add box shadow */
  box-shadow: ${({ $active }) =>
    $active ? `0px 4px 20px rgba(0, 0, 0, 0.07)` : `unset`};
  z-index: ${({ $active }) => ($active ? 100 : 1)};
  cursor: pointer;

  /* Overwrite button styles */
  background-color: #fff;
  border: none;
  outline: none;
`

interface ITestimonialSelector {
  logoImage: FluidObject
  active?: boolean
  onClick: (any) => void
}

const TestimonialSelector = ({
  logoImage,
  active = false,
  onClick,
}: ITestimonialSelector) => {
  return (
    <TestimonialSelectorButton $active={active} onClick={onClick}>
      <VariantContainer
        variants={[
          null,
          css`
            min-width: 120px;
          `,
          css`
            min-width: 140px;
          `,
        ]}
      >
        <Img fluid={logoImage} />
      </VariantContainer>
    </TestimonialSelectorButton>
  )
}
export default TestimonialSelector
